import {
  CHECK_STATUS_EVENT,
  GET_STATISTIC,
  PAIRING_EVENT_2024,
  START_OPEN_GIFT,
  HISTORY_OPEN_GIFT_NOEL,
  USER_CODE,
  CODE_DETAIL,
  RECEIVE_CODE,
  GET_RANK,
  HISTORY_OPEN_GIFT_NOEL_SPECIAL,
} from "./contants";

const initState = {
  statusEvent: null,
  statisticFirework: null,
  pairing: null,
  startOpen: null,
  historyNoel: null,
  userCode: null,
  codeDetail: null,
  receiveCode: null,
  dataRank: null,
  dataHistoryNoelSpecial: null,
};

const reducerEventNewYear2024 = (state = initState, actions) => {
  switch (actions.type) {
    case USER_CODE:
      return {
        ...state,
        userCode: actions.payload.data,
      };
    case HISTORY_OPEN_GIFT_NOEL_SPECIAL:
      return {
        ...state,
        dataHistoryNoelSpecial: actions.payload.data,
      };
    case GET_RANK:
      return {
        ...state,
        dataRank: actions.payload.data,
      };
    case CODE_DETAIL:
      return {
        ...state,
        codeDetail: actions.payload.data,
      };
    case RECEIVE_CODE:
      return {
        ...state,
        receiveCode: actions.payload.data,
      };
    case CHECK_STATUS_EVENT:
      return {
        ...state,
        statusEvent: actions.payload.data,
      };
    case GET_STATISTIC:
      return {
        ...state,
        statisticFirework: actions.payload.data,
      };
    case PAIRING_EVENT_2024:
      return {
        ...state,
        pairing: actions.payload.data,
      };
    case START_OPEN_GIFT:
      return {
        ...state,
        startOpen: actions.payload.data,
      };
    case HISTORY_OPEN_GIFT_NOEL:
      return {
        ...state,
        historyNoel: actions.payload.data,
      };
    default:
      return state;
  }
};

export default reducerEventNewYear2024;
